namespace GeniuzPOS.Purchase {
    export class PoPurRequestDtColumns {
        static columnsKey = 'Purchase.PoPurRequestDt';
    }
}
